/**
 * Application-wide configuration constants
 */

export const APP_NAME = "ADMIN";

// Add other application-wide configuration constants here as needed
export const APP_VERSION = "1.0.0";